import axios from "axios";

const axiosHttp = axios.create({
  baseURL: `http://localhost:4000`,
});

const getToken = () => {
  const Token = localStorage.getItem("AccessToken");
  return !!Token ? Token : "";
};


axiosHttp.interceptors.request.use(
  (config) => {
    const token = getToken() !== null && getToken() !== "" ? JSON.parse(getToken()) : null;
    return {
      ...config,
      headers: {
        ...(token !== null && token !== "" && { Authorization: `Bearer ${token}` }),
        ...config.headers,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem("AccessToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosHttp;